import axios from '@/user/axios'

const moduleAmcAudience = {
  namespaced: true,
  state: {
    advertisers: [],
    categories: [],
    audiences: [],
    campaignList: [],
    adCampaignList: [],
    adCampaignGroupList: [],
    lineItemList: [],
    searchKeywordList: [],
    segmentList: [],
    ecUserCategories: {},
    deliveryList: [],
  },
  mutations: {
    SET_ADVERTISER_LIST(state, payload) {
      state.advertisers = payload
    },
    SET_CATEGORY_LIST(state, payload) {
      state.categories = payload
    },
    SET_AUDIENCE_LIST(state, payload) {
      state.audiences = payload
    },
    SET_CAMPAIGN_LIST(state, payload) {
      state.campaignList = payload
    },
    SET_AD_CAMPAIGN_LIST(state, payload) {
      state.adCampaignList = payload
    },
    SET_AD_CAMPAIGN_GROUP_LIST(state, payload) {
      state.adCampaignGroupList = payload
    },
    SET_LINE_ITEM_LIST(state, payload) {
      state.lineItemList = payload
    },
    SET_SEARCH_KEYWORD_LIST(state, payload) {
      state.searchKeywordList = payload
    },
    SET_SEGMENT_LIST(state, payload) {
      state.segmentList = payload
    },
    SET_EC_USER_CATEGORY_LIST(state, payload) {
      state.ecUserCategories = payload
    },
    SET_DELIVERY_LIST(state, payload) {
      state.deliveryList = payload
    }
  },
  actions: {
    listAdvertisers(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/advertiser/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_ADVERTISER_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listCategories(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/category/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_CATEGORY_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listAudiences(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_AUDIENCE_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listCampaign(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/campaign/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_CAMPAIGN_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listAdCampaign(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/ad-campaign/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_AD_CAMPAIGN_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listAdCampaignGroup(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/ad-campaign-group/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_AD_CAMPAIGN_GROUP_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listLineItem(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/line-item/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_LINE_ITEM_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listSearchKeyword(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/search-keyword/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SEARCH_KEYWORD_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listSegment(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get(`/api/amc-reports/audience/segment`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_SEGMENT_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listEcUserCategories(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/ec-user-category/${sellerId}`, {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_EC_USER_CATEGORY_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    listDeliveries(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.get(`/api/amc-reports/audience/delivery/${sellerId}/${payload.amcAudienceId}`)
          if (res.data.success) {
            context.commit('SET_DELIVERY_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addAudience(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/amc-reports/audience/${sellerId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addDelivery(context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const sellerId = context.rootState.account.activeAccount.sellerId
          const res = await axios.post(`/api/amc-reports/audience/delivery/${sellerId}`, payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleAmcAudience
